import React, { PropTypes, PureComponent } from 'react';
import { withRouter } from 'react-router';

import { searches } from '../../../../utils/localStorage';
import { getLocalStorage, setLocalStorage, stringifyQS } from '../../../../utils';

import SearchHeader from './component';

class SearchHeaderContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.defaultLocations = {
      au: {
        name: 'Australia',
        locationName: 'Australia',
        viewportNorthEastLat: -0.69,
        viewportNorthEastLong: 166.74,
        viewportSouthWestLat: -51.66,
        viewportSouthWestLong: 100.09,
      },
      gb: {
        name: 'United Kingdom',
        locationName: 'United Kingdom',
        viewportNorthEastLat: 60.85,
        viewportNorthEastLong: 1.76,
        viewportSouthWestLat: 49.88,
        viewportSouthWestLong: -8.64,
      },
      us: {
        name: 'United States',
        locationName: 'United States',
        viewportNorthEastLat: 49.38,
        viewportNorthEastLong: -66.94,
        viewportSouthWestLat: 25.82,
        viewportSouthWestLong: -124.39,
      },
    };
    this.state = {
      values: {},
    };
  }

  componentDidMount() {
    const lastSearch = JSON.parse(getLocalStorage(searches.last.key));
    if (lastSearch) {
      const defaultLocation = Object.keys(lastSearch)
        .filter(param =>
          [
            'locationName',
            'locationLat',
            'locationLong',
            'viewportNorthEastLat',
            'viewportNorthEastLong',
            'viewportSouthWestLat',
            'viewportSouthWestLong',
          ].includes(param),
        )
        .reduce((obj, key) => ({ ...obj, [key]: lastSearch[key] }), {
          name: lastSearch.locationName,
        });
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState(state => ({
        values: {
          ...state.value,
          defaultLocation,
        },
      }));
    } else {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState(state => ({
        values: {
          ...state.value,
          defaultLocation: this.defaultLocations[this.props.countryCode.toLowerCase()],
        },
      }));
    }
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState(state => ({
      values: {
        ...state.values,
        defaultLocation: undefined,
        [name]: value,
      },
    }));
  };

  handleSubmit = () => {
    const { defaultLocation, location: place, minDate, maxDate } = this.state.values;
    const location = place // eslint-disable-line no-nested-ternary
      ? [
        'country',
        'administrative_area_level_1',
        'administrative_area_level_2',
        'bounds',
      ].includes(place.types[0])
        ? {
          locationName: place.name,
          viewportNorthEastLat: place.geometry.viewport.getNorthEast().lat(),
          viewportNorthEastLong: place.geometry.viewport.getNorthEast().lng(),
          viewportSouthWestLat: place.geometry.viewport.getSouthWest().lat(),
          viewportSouthWestLong: place.geometry.viewport.getSouthWest().lng(),
        }
        : {
          locationName: place.name,
          locationLat: place.geometry.location.lat(),
          locationLong: place.geometry.location.lng(),
        }
      : {};
    const query = {
      ...this.props.query,
      ...(location.locationName ? location : defaultLocation),
      locationSearchRadius: location.locationLat ? 50 : null,
      minDate,
      maxDate,
      name: undefined,
    };
    setLocalStorage(searches.last.key, JSON.stringify(query));
    this.props.router.push(`/s?${stringifyQS(query)}`);
  };

  render() {
    return (
      <SearchHeader
        onDateChange={this.handleChange}
        onLocationChange={this.handleChange}
        onSubmit={this.handleSubmit}
        {...this.props}
        {...this.state}
      />
    );
  }
}

SearchHeaderContainer.propTypes = {
  countryCode: PropTypes.string,
  query: PropTypes.shape().isRequired,
  router: PropTypes.shape().isRequired,
};

SearchHeaderContainer.defaultProps = {
  countryCode: 'gb',
};

export default withRouter(SearchHeaderContainer);



// WEBPACK FOOTER //
// ./app/src/components/Discovery/components/SearchHeader/container.jsx